import { render } from "./ErrorIcon.vue?vue&type=template&id=4560ea7e"
import script from "./ErrorIcon.vue?vue&type=script&lang=js"
export * from "./ErrorIcon.vue?vue&type=script&lang=js"

import "./ErrorIcon.vue?vue&type=style&index=0&id=4560ea7e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__